import React from 'react';
import { ColorSwatch } from '@hexcrawl/shared-utils';
import { ColorSwatchPicker } from './ColorSwatchPicker';

interface Props {
  enabled: boolean;
  hex: string | undefined;
  palette: ColorSwatch[];
  onToggle: () => void;
  onColorChange: (hex: string) => void;
}

export const ToggleWithColor: React.FC<Props> = ({ enabled, hex, palette, onToggle, onColorChange }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <button
          onClick={onToggle}
          style={{
            width: 44,
            height: 24,
            borderRadius: 12,
            border: 'none',
            background: enabled ? '#4CAF50' : '#555',
            cursor: 'pointer',
            position: 'relative',
            padding: 0,
          }}
        >
          <span
            style={{
              position: 'absolute',
              top: 3,
              left: enabled ? 22 : 3,
              width: 18,
              height: 18,
              borderRadius: '50%',
              background: '#fff',
              transition: 'left 0.15s',
            }}
          />
        </button>
        <span style={{ fontSize: 13, color: enabled ? '#fff' : '#888' }}>
          {enabled ? 'On' : 'Off'}
        </span>
      </div>
      {enabled && (
        <ColorSwatchPicker
          palette={palette}
          selected={hex ?? palette[0]?.hex ?? ''}
          onChange={onColorChange}
        />
      )}
    </div>
  );
};
